<template>
    <Bar />
    <div class="background">
        <div class="users">
            <div class="view-controls">
                <input type="text" v-model="searchQuery" class="search-bar" placeholder="Search users..." />
            </div>

            <table class="users-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Credits</th>
                        <th>Server Count</th>
                        <th>Server Slots</th>
                        <th>Email Verified</th>
                        <th>Discord Verified</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in filteredUsers" :key="user['id']">
                        <td>{{ user["id"] }}</td>
                        <td>{{ user["name"] }}</td>
                        <td>{{ user["role"] }}</td>
                        <td>{{ user["credits"] }}</td>
                        <td>{{ user["server_count"] }}</td>
                        <td>{{ user["server_slots"] }}</td>
                        <td>{{ user["email_verified"] }}</td>
                        <td>{{ user["discord_verified"] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Bar from '@/components/Bar.vue';
import { getAllUserData } from '@/composables/api';
import router from '@/router';
import { updateStoreData } from '@/composables/store';

const store = useStore();
const sidebarWidth = computed(() => store.getters.sidebarWidth);

const users = ref([]);
const searchQuery = ref('');

const openInNewTab = (url) => {
    window.open(url, '_blank');
};

const filteredUsers = computed(() =>
    users.value.filter(user =>
        user.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        user.role.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        (user.id && String(user.id).includes(searchQuery.value))
    )
);



onMounted(async () => {
    const success = await updateStoreData();
    if (!success) {
        router.push('/login');
        return;
    }
    const result = await getAllUserData();
    if (result.success === 400) {
        router.push('/login');
    } else if (result.success === 403) {
        router.push('/dashboard');
    } else {
        users.value = result.users;
    }
});
</script>

<style>
.users {
    padding-top: 100px;
    text-align: center;
    min-height: 100vh;
    transition: margin-left 0.3s ease, width 0.3s ease;
    margin-left: calc(var(--sidebar-width));
}

.view-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}

.users-table {
    width: 80%;
    margin: 0 auto;
    border-collapse: collapse;
    text-align: left;
    padding-bottom: 20px;
}

.users-table th,
.users-table td {
    padding: 10px 15px;
    border: 1px solid #ddd;
}

.users-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.search-bar {
    width: 300px;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
}
</style>